import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionTemplateCheckPermissionsPathParameters } from 'api/actions/revision-template-check-permissions/revision-template-check-permissions-path-parameters';
import { RevisionTemplateCheckPermissionsResponse } from 'api/actions/revision-template-check-permissions/revision-template-check-permissions-response';

type RevisionTemplateCheckPermissionsQueryParameters = Record<string, any>;

/**
 * The path of the RevisionTemplateCheckPermissions action.
 */
export const revisionTemplateCheckPermissionsActionPath = new SweetPath<
  keyof RevisionTemplateCheckPermissionsPathParameters
>('/api/revision-template/check-permissions/{revisionTemplateId}', { path: '{param}' });

/**
 * Creates a contextualized RevisionTemplateCheckPermissions actions.
 */
export default function createRevisionTemplateCheckPermissionsAction(axios: AxiosInstance) {
  return function revisionTemplateCheckPermissionsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionTemplateCheckPermissionsPathParameters;
    query?: RevisionTemplateCheckPermissionsQueryParameters;
  }) {
    const path = revisionTemplateCheckPermissionsActionPath.insert(parameters);

    return axios.request<RevisionTemplateCheckPermissionsResponse, RevisionTemplateCheckPermissionsResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
